const mutationEcer = `mutation generateEcer($slug: String!, $record: TimeInput){
  generateEcer(slug: $slug, record: $record)
}`

module.exports = {
  mutationEcer,
}



// WEBPACK FOOTER //
// ./src/CreateEcer/mutation.js